import {$state} from 'root/angular-injector-provider';
import {HOTEL_RFP_BID_NEGOTIATIONS} from 'root/states';


export function openNegotiationsBidManagerAction(report){
  return {
    label: 'Negotiate',
    icon: 'forum',
    action () {
      openNegotiations(report.bids[0]._id);
    }
  };
}

export function openNegotiations(bidId) {
  $state().inNew(HOTEL_RFP_BID_NEGOTIATIONS, {bidId});
}
